import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PublicLayout, Container } from '../../components/layout';

interface SupportLayoutProps {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
}

export const SupportLayout: React.FC<SupportLayoutProps> = ({ title, subtitle, children }) => {
  const navigate = useNavigate();

  return (
    <PublicLayout>
      <Container className="py-16">
        <div className="max-w-3xl mx-auto">
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="mb-8 flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            Back
          </button>

          <h1 className="text-4xl font-bold text-gray-900 mb-3">{title}</h1>
          {subtitle && <p className="text-lg text-gray-600 mb-10">{subtitle}</p>}

          <div className="prose prose-lg max-w-none">{children}</div>
        </div>
      </Container>
    </PublicLayout>
  );
};

export default SupportLayout;
